export function formatEmailForWrapping(email?: string | null): string | undefined {
    if (!email) {
        return undefined;
    }

    return email.replace(/([@._-])/g, "$1\u200B");
}
